import { faEnvelope, faMapMarkerAlt, faPhoneAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import './Contact.css';
import emailjs from 'emailjs-com';

const Contact = () => {

    function sendEmail(e) {
        e.preventDefault();

        emailjs.sendForm('gmail', 'template_qq85vps', e.target, 'user_8u4OZGOhfbxMkniUcNwek')
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });
        e.target.reset();
    }


    return (
        <section className="contact" id="contact">
            <div className="max-width">
                <h2 className="title">
                    Contact me</h2>
                <div className="contact-content">
                    <div className="column left">
                        <div className="text">
                            Get in Touch</div>
                        <p>
                            Feel free to contact with me. If you have any query or you want to
                            know more about something, write your message I will try to reply you as much as possible.
                        </p>
                        <div className="icons">
                            <div className="contact-row">
                                <FontAwesomeIcon className="contact-icon" icon={faPhoneAlt}></FontAwesomeIcon>
                                <div className="info">
                                    <div className="head">
                                        Phone</div>
                                    <div className="sub-title">
                                        +01758416616</div>
                                </div>
                            </div>
                            <div className="contact-row">
                                <FontAwesomeIcon className="contact-icon" icon={faMapMarkerAlt}></FontAwesomeIcon>
                                <div className="info">
                                    <div className="head">
                                        Address</div>
                                    <div className="sub-title">
                                        Shukrabad, Dhanmondi, Dhaka</div>
                                </div>
                            </div>
                            <div className="contact-row">
                                <FontAwesomeIcon className="contact-icon" icon={faEnvelope}></FontAwesomeIcon>
                                <div className="info">
                                    <div className="head">
                                        Email</div>
                                    <div className="sub-title">
                                        farhadswe35@gmail.com</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="column right">
                        <div className="text">
                            Write Message</div>
                        <form action="#" onSubmit={sendEmail}>
                            <div className="fields">
                                <div className="field name">
                                    <input type="text" placeholder="Name" name="name" required />
                                </div>
                                <div className="field email">
                                    <input type="email" placeholder="Email" name="email" required />
                                </div>
                            </div>
                            <div className="field">
                                <input type="text" placeholder="Subject" name="subject" required />
                            </div>
                            <div className="field textarea">
                                <textarea cols="30" rows="10" placeholder="Message.." name="message" required ></textarea>
                            </div>
                            <div className="button">
                                <button type="submit">Send message</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section >

    );
};

export default Contact;